import React from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Skeleton,
} from "@mui/material";

const headerCellStyle = {
  fontSize: "14px",
  color: "rgba(62, 63, 76, 0.75)",
  fontWeight: 400,
  padding: "13px 16px",
  borderBottom: "1px solid rgba(234, 234, 234, 1)",
  borderTop: "1px solid rgba(234, 234, 234, 1)",
};

const tableCellStyles = {
  color: "rgba(62, 63, 76, 1)",
  fontWeight: 400,
  borderBottom: "1px solid rgba(234, 234, 234, 1)",
  padding: "16px",
};

const SkeletonTable = ({ columns = [], rowCount = 5 }) => {
  return (
    <TableContainer
      sx={{
        height: "100%",
        overflow: "auto",
        position: "relative",
        flex: 1,
        paddingRight: "8px",
      }}
    >
      <Table
        stickyHeader
        sx={{
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: "16px",
          border: "1px solid rgba(234, 234, 234, 1)",
          borderTop: "none",
        }}
      >
        <TableHead>
          <TableRow>
            {columns.map((_, index) => (
              <TableCell
                key={`header-skeleton-${index}`}
                sx={{
                  position: "sticky",
                  top: 0,
                  fontWeight: 500,
                  borderTopLeftRadius: index === 0 ? "16px" : "0px",
                  borderTopRightRadius:
                    index === columns.length - 1 ? "16px" : "0px",
                  ...headerCellStyle,
                }}
              >
                <Skeleton variant="text" width={80} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <TableRow key={`skeleton-row-${rowIndex}`}>
              {columns.map((__, colIndex) => (
                <TableCell
                  key={`skeleton-cell-${rowIndex}-${colIndex}`}
                  sx={{
                    ...tableCellStyles,
                    borderBottomLeftRadius:
                      rowIndex === rowCount - 1 && colIndex === 0 ? "16px" : 0,
                    borderBottomRightRadius:
                      rowIndex === rowCount - 1 &&
                      colIndex === columns.length - 1
                        ? "16px"
                        : 0,
                    overflow: "hidden",
                  }}
                >
                  <Skeleton variant="text" width="80%" />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SkeletonTable;
